import { render, staticRenderFns } from "./NotificationManager.vue?vue&type=template&id=44414c4e&scoped=true&"
import script from "./NotificationManager.vue?vue&type=script&lang=js&"
export * from "./NotificationManager.vue?vue&type=script&lang=js&"
import style0 from "./NotificationManager.vue?vue&type=style&index=0&id=44414c4e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44414c4e",
  null
  
)

export default component.exports